import { render, staticRenderFns } from "./OrdersByStatus.vue?vue&type=template&id=ad006f2c&scoped=true&"
import script from "./OrdersByStatus.vue?vue&type=script&lang=js&"
export * from "./OrdersByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad006f2c",
  null
  
)

export default component.exports